export default __webpack_public_path__ + "static/media/img-1.0688bacf.jpg";